import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { DOCUMENT_MODULE_NAMESPACE, DOCUMENT_GET_DOCUMENTS, DOCUMENT_GET_DOCUMENTS_SIDEBAR } from '../../../../store/document';
import { IBlockParameter, IBlockListingViewModel } from '../../../../models/block';
import { IDocumentListingViewmodel, DocumentParamter } from '../../../../models/documents';
import { ITEM_LIMITATION } from '../../../../common/constants';

const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)

@Component
class BlockSidebarWidgetDocuments extends Vue {


  @Prop({ default: null, type: [String] })
  path: string;

  /**
   *
   */
  constructor() {
    super();
  }
  @DocumentStore.Getter sidebarDocuments: IDocumentListingViewmodel[];

  @DocumentStore.Action(DOCUMENT_GET_DOCUMENTS_SIDEBAR)
  storeGetDocuments: (payload: { blockId: string, param: IBlockParameter }) => Promise<IBlockListingViewModel[]>


  mounted() {
    this.handleGetDocuments();
  }

  get coDocuments(): IDocumentListingViewmodel[] {
    return this.sidebarDocuments;
  }
  @Watch('$route.params.id')
  handleGetDocuments() {
    this.storeGetDocuments({
      blockId: this.$route.params.id,
      param: new DocumentParamter({ $limit: ITEM_LIMITATION })
    })

  }
}

export default BlockSidebarWidgetDocuments;


// WEBPACK FOOTER //
// ./src/containers/block/components/block-sidebar-widget-documents/index.ts